import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";
import ImageURL from "../../../config/ImageURL";
import Modal from "react-bootstrap/Modal";
import NoImage from "../../../assets/noImage.webp";

function VoucherView() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/vouchers/${id}`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const stripHtmlTags = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleToggleStatus = async () => {
    setLoading(true);
    try {
      const response = await api.post(`admin/toggl-voucher-status/${id}`);
      if (response.status === 200) {
        toast.success(response.data.message);
        getData(); // Refresh data to reflect the updated status
        handleClose();
      } else {
        toast.error(response.data.message || "Failed to toggle status");
      }
    } catch (error) {
      toast.error("An error occurred while toggling the voucher status.");
      console.error("Toggle Status Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">View Vouchers</h3>
                </div>
                <div>
                  <button
                    onClick={handleOpenModal}
                    className={`btn btn-sm me-2 ${
                      data?.is_active ? "btn-danger" : "btn-success"
                    }`}
                  >
                    {data?.is_active ? "Deactivate" : "Activate"}
                  </button>
                  <Link to="/voucher">
                    <button type="button" className="btn btn-light btn-sm me-2">
                      <span>Back</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container card shadow border-0"
            style={{ minHeight: "80vh" }}
          >
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Title</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.title || ""}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.code || ""}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Type</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.type || ""}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Start Date</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.start_date}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">End Date</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.end_date}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Amount</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.amount || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Description</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.description}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Minimum Purchase Amount</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.min_pruchase_amount || "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Image</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      {data?.image ? (
                        <img
                          src={
                            data?.image ? `${ImageURL}${data.image}` : NoImage
                          }
                          alt="icon"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      ) : (
                        "{NoImage}"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row mb-3">
                  <div className="col-12 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Applied to these products</p>
                  </div>
                  <div className="col-12">
                    <p className="text-muted text-sm">
                      {Array.isArray(data?.products) &&
                      data?.products.length > 0
                        ? data?.products.map((p) => p.name).join(", ")
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row mb-3">
                  <div className="col-12 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Applied to these users</p>
                  </div>
                  <div className="col-12">
                    <p className="text-muted text-sm">
                      {Array.isArray(data?.users) && data?.users.length > 0
                        ? data?.users.map((u) => u.name).join(", ")
                        : "-"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="row mb-3">
                  <div className="col-12 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Terms</p>
                  </div>
                  <div className="col-12">
                    <p className="text-muted text-sm">
                      {stripHtmlTags(data?.terms)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={showModal}
            backdrop="static"
            keyboard={false}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {data?.is_active ? "Deactivate Voucher" : "Activate Voucher"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to{" "}
              {data?.is_active ? "deactivate" : "activate"} this voucher?
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-sm btn-button" onClick={handleClose}>
                Close
              </button>
              <button
                className={`btn btn-sm ${
                  data?.is_active ? "btn-danger" : "btn-success"
                }`}
                type="submit"
                onClick={handleToggleStatus}
                disabled={loading}
              >
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    aria-hidden="true"
                  ></span>
                )}
                {data?.is_active ? "Deactivate" : "Activate"}
              </button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </section>
  );
}

export default VoucherView;
